import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const ICONS = [
  'ri-building-2-line',
  'ri-car-line',
  'ri-file-check-line',
  'ri-scales-3-line',
];

export default function UseCasesSection() {
  const { t } = useTranslation('home');
  const cases = t('useCases.items', { returnObjects: true }) as Array<{
    label: string;
    title: string;
    description: string;
  }>;

  return (
    <section className="bg-[#F6F2EC] py-24 border-t border-[#E7E1D9]">
      <div className="max-w-[1440px] mx-auto px-8 lg:px-16">
        {/* Header */}
        <div className="max-w-[640px] mb-16">
          <p className="text-[11px] uppercase tracking-[0.12em] font-medium text-[#F97700] mb-4">
            {t('useCases.eyebrow')}
          </p>
          <h2 className="text-4xl font-semibold text-[#0B0B0B] leading-[1.2] mb-5">
            {t('useCases.title')}
          </h2>
          <p className="text-[15px] text-[#5A5248] leading-relaxed">
            {t('useCases.subtitle')}
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {Array.isArray(cases) && cases.map((item, i) => (
            <div
              key={i}
              className="group bg-white border border-[#E7E1D9] rounded-lg p-8 hover:border-[#F97700] transition-all duration-400 relative overflow-hidden cursor-default"
            >
              {/* Subtle background accent on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#F97700]/4 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />

              {/* Step number */}
              <span className="absolute top-6 right-6 text-[56px] font-light leading-none text-[#F6F2EC] select-none pointer-events-none group-hover:text-[#F97700]/8 transition-colors duration-400">
                0{i + 1}
              </span>

              {/* Icon */}
              <div className="w-10 h-10 flex items-center justify-center mb-6 relative z-10">
                <i className={`${ICONS[i]} text-3xl text-[#F97700]`}></i>
              </div>

              {/* Label */}
              <p className="text-[10px] uppercase tracking-[0.1em] font-medium text-[#9A9288] mb-3 relative z-10">
                {item.label}
              </p>

              {/* Title */}
              <h3 className="text-[17px] font-semibold text-[#0B0B0B] leading-snug mb-3 relative z-10">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-[13px] text-[#5A5248] leading-relaxed relative z-10">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Soft CTA */}
        <div className="mt-12 flex items-center gap-2">
          <div className="w-6 h-0.5 bg-[#F97700]"></div>
          <Link
            to="/diagnostico"
            className="text-[13px] font-medium text-[#0B0B0B] hover:text-[#F97700] transition-colors duration-300 cursor-pointer"
          >
            {t('useCases.cta')} →
          </Link>
        </div>
      </div>
    </section>
  );
}
